import merge from 'lodash/merge';

import applicationConfiguration from './application-configuration';
import applicationLocalization from './application-localization';

export default (applicationContext) => {
	const defaults = {
		applicationId: 'missing-persons',
		applicationName: 'Missing Persons',
		applicationConfiguration,
		applicationLocalization,
	};

	return merge(defaults, applicationContext);
};
